module.exports = __webpack_public_path__ + "img/manuela.ec058b25.svg";